import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\xampp\\htdocs\\enthioshub\\enthioshub\\frontend\\src\\app\\legal\\LegalIndexClient.tsx");
